module.exports = __webpack_public_path__ + "img/janariLogo.1dfaa453.png";